<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      topHeight: 0,
      bottomHeight: 0,
    }
  },
  methods: {
    setHeights: function() {
      this.topHeight = 0
      this.bottomHeight = 0
      const children = this.$el.children

      // first, find the max heights for both sections
      for (var i = 0; i < children.length; i++) {
        let top = children[i].getElementsByClassName('card_3up-card-heading')[0]
        top.style.height = 'unset'
        if (top.clientHeight > this.topHeight) {
          this.topHeight = top.clientHeight
        }
      }

      for (var j = 0; j < children.length; j++) {
        children[j].getElementsByClassName(
          'card_3up-card-heading'
        )[0].style.height = this.topHeight + 'px'
      }
    },

    resetHeights: function() {
      const children = this.$el.children

      // first, find the max heights for both sections
      for (var i = 0; i < children.length; i++) {
        let top = children[i].getElementsByClassName('card_3up-card-heading')[0]
        top.style.height = 'unset'
      }
    },
  },
  mounted() {
    if (window.innerWidth >= 640) {
      this.setHeights()
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 640) {
        this.setHeights()
      } else {
        this.resetHeights()
      }
    })
  },
}
</script>
